<template>
  <div class="hero-section flex flex-col flex-wrap w-full px-5 py-5 md:py-5">
    <div class="flex-1 mt-auto mb-8">
      <div class="ml-4 mt-2 md:mt-8">
        <p class="text-2xl md:text-5xl mt-2 md:mt-4">
          Build a bet with friends
        </p>
        <p class="text-lg md:text-3xl mt-2 md:mt-4">
          <i class="pi pi-check"></i> Easy and Fast. Type or speak your bet
          selections.
        </p>
        <p class="text-lg md:text-3xl mt-2 md:mt-4">
          <i class="pi pi-check"></i> Share with friends to start the
          conversation. Even without placing.
        </p>
        <p class="text-lg md:text-3xl mt-2 md:mt-4">
          <i class="pi pi-check"></i> Open bet at anytime into Bookmakers
          betslip.
        </p>

        <!--        <div class="hidden md:block">Visible on md+</div>-->

        <!--                <div class="block md:hidden">-->
        <!--                  <div class="flex align-items-center justify-content-center p-4 pb-8 w-full mt-8">-->
        <!--                    <HeaderLogo />-->
        <!--                  </div>-->
        <!--                </div>-->

        <!--        <div class="block md:hidden">Mobile only</div>-->

        <!--        <StartButton class="mt-8" />-->

        <!--        <p class="text-xl md:text-5xl mt-6">Your Winning Edge in Sports Betting</p>-->
        <!--        <p class="text-xl md:text-5xl mt-6">Your</p>-->
      </div>
    </div>

    <div class="flex-1">
      <div class="align-self-center">
        <div class="px-6 pb-8 w-full">
          <!--          <HeaderLogo />-->
        </div>
      </div>
    </div>

    <!--    <div class="flex align-items-center justify-content-center px-6 pb-8 w-4">-->
    <!--      <HeaderLogo />-->
    <!--    </div>-->

    <div class="flex-1">
      <StartButton class="mt-4 md:mt-8" />
      <p class="text-xl md:text-5xl mt-6">Building your bets with friends</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import StartButton from "@/components/button/StartButton.vue";
import HeaderLogo from "@/components/header/HeaderLogo.vue";
</script>

<style scoped>
.hero-section {
  min-height: 80vh;
  width: 100%;
  background:
    linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8)),
    url("@/assets/images/stadium-resized.jpeg");
  background-size: cover;
  background-position: center;
  color: #ffffff;
}
</style>
